import { Button } from '@mui/material';
import useResyncProjects from 'app/hooks/use-resync-projects';

type ProjectListActionsRightProps = {
	toggleCreateNewProject: () => void;
	/** The Add button is shown only when the list is loaded and not empty (the empty state has its own). */
	showAdd?: boolean;
};

export default function ProjectListActionsRight({ toggleCreateNewProject, showAdd = true }: ProjectListActionsRightProps) {
	const reSyncAll = useResyncProjects();

	return (
		<>
			{/* TODO: Move to separate component for web and desktop*/}
			<Button
				color="secondary"
				onClick={reSyncAll}
				sx={!!reSyncAll ? { display: 'none' } : {}}>
				Sync projects
			</Button>
			{showAdd && <Button onClick={toggleCreateNewProject}>Add</Button>}
		</>
	);
}
